import React, { useMemo } from 'react';
import UploadIcon from '../../../Assets/newUpload.svg';
import style from './index.module.css';
import uploadv0 from '../../../Assets/uploadv0.svg';

const SecondForm = ({ changeImage, input }) => {
  const preview = useMemo(() => {
    return input.file && typeof input.file !== 'string'
      ? URL.createObjectURL(input.file)
      : null;
  }, [input.file]);
  // console.log('prev', preview);

  return (
    <div className={style.seccont}>
      <div className={style.uploadphoto}>
        <div className={style.plus}>
          {preview === null ? (
            <img src={uploadv0} alt='uploadv0' />
          ) : (
            <img src={preview} alt='' className={style.preview} />
          )}
        </div>
      </div>
      <label htmlFor='file' className={style.uploadBtn}>
        <img src={UploadIcon} alt='' />
        <input
          id='file'
          type='file'
          placeholder='Profile Photo'
          name='file'
          onChange={changeImage}
          hidden
          autoComplete='off'
        />
        Upload
      </label>
    </div>
  );
};

export default SecondForm;
